import BaseModelAPI from '../BaseModelAPI';

export default class DocumentAttachment extends BaseModelAPI {
	static entity = 'documentattachment';
	static entityName = 'documentattachment';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.documentAttachmentDetails = []
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}